export class ProductModel {
    constructor(id, title, description, category, price, imageUrl, gallery, fileUrl, liked, free) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.category = category;
        this.price = price;
        this.imageUrl = imageUrl;
        this.gallery = gallery;
        this.fileUrl = fileUrl;
        this.liked = liked;
        this.free = free
    }
}